const CLIENT_ID = process.env.SPOTIFY_CLIENT_ID
const RESPONSE_TYPE = 'token'
const SCOPE = [
  'user-read-private',
  'playlist-modify-public',
  'playlist-modify-private',
  'ugc-image-upload',
  'user-follow-read',
  'user-library-read',
  'user-read-private',
  'user-top-read',
  'user-read-recently-played'
].join('%20')

const LS_EXPIRY_KEY = 'tokenExpires'
const LS_TOKEN_KEY = 'token'

export const login = clientId => {
  return new Promise((resolve, reject) => {
    const REDIRECT_URI = encodeURIComponent(
      `${window.location.origin}/callback/`
    )
    const LOGIN_URL = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=${RESPONSE_TYPE}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}`
    const popup = window.open(
      LOGIN_URL,
      '_blank',
      'width=500,height=700,toolbar=0,menubar=0,location=0,status=1,scrollbars=0,resizable=0,left=0,top=0'
    )

    const listener = setInterval(() => {
      if (popup) {
        popup.postMessage('login', window.location)
      } else {
        const localToken = getToken()
        if (localToken) {
          resolve(localToken)
          window.onmessage = null
        }
      }
    }, 1000)

    window.onmessage = event => {
      const message = event.data
      clearInterval(listener)
      storeToken(message)
      resolve(message)
      window.onmessage = null
    }
  })
}

export const logout = () => {
  localStorage.removeItem(LS_EXPIRY_KEY)
  localStorage.removeItem(LS_TOKEN_KEY)
}

export const storeToken = (token, expiry = 3600) => {
  localStorage.setItem(LS_TOKEN_KEY, token)
  localStorage.setItem(LS_EXPIRY_KEY, new Date().getTime() + expiry * 1000)
}

export const getToken = () => {
  const token = localStorage.getItem(LS_TOKEN_KEY)
  const expiry = localStorage.getItem(LS_EXPIRY_KEY)

  const timeNow = new Date().getTime()
  const expired = isNaN(expiry) ? true : expiry < timeNow

  if (!token || expired) {
    logout()
    return null
  }

  return token
}



// WEBPACK FOOTER //
// ./src/services/spotify.js